<template>
  {{ currentTime }}
</template>

<script>
export default {
  props: {
    timeZoneName: {
      type: String,
      required: true,
      default: 'Australia/Brisbane',
    },
    offset: {
      type: Number,
      required: true,
      default: 10,
    },
  },
  data() {
    return {
      currentTime: '',
      timeInterval: null,
    };
  },
  mounted() {
    this.updateTime(); // Set initial time
    
    // Start with rapid updates
    this.timeInterval = setInterval(() => {
      this.updateTime();
      this.initialCount++;
      
      // After 10 updates (10 seconds), switch to minute updates
      if (this.initialCount === 10) {
        clearInterval(this.timeInterval);
        this.timeInterval = setInterval(this.updateTime, 60000);
      }
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timeInterval); // Clear the interval when the component is unmounted
  },
  methods: {
    updateTime() {
      // Create a new date object for the current time
      const now = new Date();
      // Calculate the UTC time based on the offset
      const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
      const localTimeWithOffset = new Date(utcTime + (this.offset * 3600000));
      
      // Format the time using Intl.DateTimeFormat
      const options = {
        timeZone: this.timeZoneName,
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      };
      this.currentTime = new Intl.DateTimeFormat('en-US', options).format(localTimeWithOffset);
    },
  },
};
</script>